import { ExecutionEnvironmentUtils } from "@gt/common-utils/build/general/ExecutionEnvironmentUtils";

export function useIsNodeJs(): boolean {
  return ExecutionEnvironmentUtils.isNode();
}
